/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_related_products = /** @type {(inputs: {}) => string} */ () => {
	return `Stejný model`
};

const da_related_products = /** @type {(inputs: {}) => string} */ () => {
	return `Relaterede produkter`
};

const de_related_products = /** @type {(inputs: {}) => string} */ () => {
	return `Ähnliche Produkte`
};

const en_related_products = /** @type {(inputs: {}) => string} */ () => {
	return `Related products`
};

const es_related_products = /** @type {(inputs: {}) => string} */ () => {
	return `Del mismo modelo`
};

const fr_related_products = /** @type {(inputs: {}) => string} */ () => {
	return `Du même modèle`
};

const hu_related_products = /** @type {(inputs: {}) => string} */ () => {
	return `Azonos modell`
};

const it_related_products = /** @type {(inputs: {}) => string} */ () => {
	return `Dello stesso modello`
};

const nl_related_products = /** @type {(inputs: {}) => string} */ () => {
	return `Vergelijkbare producten`
};

const pl_related_products = /** @type {(inputs: {}) => string} */ () => {
	return `Podobne produkty`
};

const pt_related_products = /** @type {(inputs: {}) => string} */ () => {
	return `Do mesmo modelo`
};

const sv_related_products = /** @type {(inputs: {}) => string} */ () => {
	return `Liknande produkter`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const related_products = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.related_products(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("related_products", locale)
	if (locale === "cs") return cs_related_products(inputs)
	if (locale === "da") return da_related_products(inputs)
	if (locale === "de") return de_related_products(inputs)
	if (locale === "en") return en_related_products(inputs)
	if (locale === "es") return es_related_products(inputs)
	if (locale === "fr") return fr_related_products(inputs)
	if (locale === "hu") return hu_related_products(inputs)
	if (locale === "it") return it_related_products(inputs)
	if (locale === "nl") return nl_related_products(inputs)
	if (locale === "pl") return pl_related_products(inputs)
	if (locale === "pt") return pt_related_products(inputs)
	return sv_related_products(inputs)
};